export enum DataStatus {
    OK,
    NoData,
    Error
}
